import { render, staticRenderFns } from "./ImageMedia.vue?vue&type=template&id=f48641b8&scoped=true"
import script from "./ImageMedia.vue?vue&type=script&lang=js"
export * from "./ImageMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48641b8",
  null
  
)

export default component.exports